import { useAuth } from '@/hooks/auth/use-auth';
import { AgeVerificationRequired } from '../components/age-verification-required';
import { Underage } from '../components/underage';
import { CreatePayoutAccount } from '../components/create-payout-account';
import { PayoutAccountList } from '../components/payout-account-list';
import { usePayoutAccountsSuspense } from '../api/list-payout-accounts';
import { useQueryParams } from '@/hooks/shared/use-query-params';

const AGE_LIMIT = 18;

export function PayoutAccounts() {
  const bankid = useQueryParams().getQueryParamByKey('bankid');
  const { context } = useAuth();
  const { data: accounts } = usePayoutAccountsSuspense({ groupId: context!.groupId });

  const age = context!.age;

  if (!age) return <AgeVerificationRequired showReloadAlert={!age && bankid === 'done'} />;

  if (age < AGE_LIMIT) return <Underage />;

  return (
    <div className="grow">
      <div className="p-6 space-y-4 relative">
        <section className="mb-5">
          <h2 className="text-2xl text-gray-800 dark:text-gray-100 font-bold mb-2">Utbetalning</h2>
          <div className="text-sm mb-3">
            Piggo fixar betalning direkt till ert utbetalningskonto. Välj mellan Swish eller banköverföring.
          </div>
        </section>

        <section>
          <header className="flex items-center justify-between mb-3">
            <h2 className="text-xl leading-snug text-gray-800 dark:text-gray-100 font-bold">Utbetalningskonton</h2>
            <CreatePayoutAccount />
          </header>

          <PayoutAccountList accounts={accounts} />
        </section>
      </div>
    </div>
  );
}
